import { defineComponent, computed, defineAsyncComponent } from "vue";
import { getEnergyEfficiencyProduct } from "@i22/rocket";
import { getConfig } from "./component-library2.mjs";
import Icon from "./component-library48.mjs";
import Datasheet from "./component-library47.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "energy-label",
  props: {
    energyClass: { default: void 0 },
    product: { default: void 0 },
    alignment: { default: "default" },
    noDataSheet: { type: Boolean },
    isInternalLink: { type: Boolean },
    reverse: { type: Boolean }
  },
  emits: ["click", "open-document"],
  setup(__props, { expose }) {
    const props = __props;
    const alignDropdown = computed(() => {
      if (["bottom", "left"].includes(props.alignment))
        return "left";
      return "right";
    });
    const containerClass = computed(() => {
      return {
        [`energy-label--${props.alignment}`]: true,
        "energy-label--reverse": props.reverse
      };
    });
    const energyLabel = computed(() => {
      if (!(props == null ? void 0 : props.product))
        return void 0;
      return getEnergyEfficiencyProduct(props.product);
    });
    const energyClassName = computed(() => {
      var _a, _b;
      if (props.energyClass)
        return props.energyClass;
      if ((_a = energyLabel.value) == null ? void 0 : _a.class)
        return (_b = energyLabel.value) == null ? void 0 : _b.class;
      return void 0;
    });
    const openEnergyModal = () => {
      if (!energyLabel.value)
        return;
      const globalModal = getConfig().globalModal || void 0;
      if (!(globalModal == null ? void 0 : globalModal.openModal))
        return;
      globalModal.openModal({
        component: {
          is: defineAsyncComponent(() => import("./component-library49.mjs")),
          props: {
            energyLabel: energyLabel.value
          }
        }
      });
    };
    expose({ openEnergyModal });
    return { __sfc: true, props, alignDropdown, containerClass, energyLabel, energyClassName, openEnergyModal, Icon, Datasheet };
  }
});
export {
  _sfc_main as default
};
